import React, { useState, useEffect } from 'react';

function YearSection() {
    const [sheetsData, setSheetsData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAllSheets = async () => {
            const sheetId = '135y3p3u2Q_EcCQoo516rzQMPj-pwdy61HSWNYxyB4rs';
            const apiKey = 'AIzaSyDC7jo5I2p7SEwALNWICtbAc85LbD7xgO8'; // Remplacez par votre clé API

            try {
                // 1. Récupérer la liste des feuilles
                const metadataResponse = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}?key=${apiKey}`);
                if (!metadataResponse.ok) {
                    throw new Error('Erreur lors de la récupération des métadonnées de la feuille');
                }
                const metadata = await metadataResponse.json();
                const sheetNames = metadata.sheets.map(sheet => sheet.properties.title);

                // 2. Récupérer les données de chaque feuille
                const allSheets = {};
                for (const sheetName of sheetNames) {
                    const response = await fetch(`https://opensheet.elk.sh/${sheetId}/${sheetName}`);
                    if (!response.ok) {
                        console.error(`Erreur lors de la récupération de la feuille ${sheetName}`);
                        continue;
                    }
                    const jsonData = await response.json();
                    allSheets[sheetName] = jsonData;
                }

                setSheetsData(allSheets);
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAllSheets();
    }, []);

    if (isLoading) {
        return <div>Chargement des données...</div>;
    }

    if (error) {
        return <div>Erreur : {error}</div>;
    }

    // Fonction pour vérifier si une famille existe et n'est pas vide
    const renderFamille = (row, familleKey) => {
        return row[familleKey] ? (
            <p><strong>{familleKey} :</strong> {row[familleKey]}</p>
        ) : null;
    };

    return (
        <div>
            {Object.keys(sheetsData).map(sheetName => (
                <div key={sheetName} style={{ marginBottom: '40px' }}>
                    <h2>{sheetName}</h2>
                    {sheetsData[sheetName].map((row, index) => (
                        <div key={index} style={{ marginBottom: '10px', padding: '10px', border: '1px solid #ccc' }}>
                            <p><strong>date :</strong> {row.date}</p>
                            {renderFamille(row, 'famille1')}
                            {renderFamille(row, 'famille2')}
                            {renderFamille(row, 'famille3')}
                            {renderFamille(row, 'famille4')}
                            {renderFamille(row, 'famille5')}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default YearSection;
